/** BFF отдаёт `next` относительным путём («/api/bff/v1/experiences?...»), поэтому парсим с базой. */
export const getQueryParams = (urlString: string) => {
  try {
    const url = new URL(urlString, window.location.origin);

    return Object.fromEntries(url.searchParams);
  } catch (error) {
    console.error('Передан невалидный URL', error);
    return {};
  }
};
